
import Vue from 'vue';

export default Vue.extend({
  name: 'CheckoutFaq',
  data() {
    // todo
    return {
      faqs: [
        {
          title: 'Kan ik mijn reservering nog wijzigen?',
          content: 'Je kan tot 7 dagen voor het diner altijd nog dingen wijzigen, daarna in overleg met je cateraar. Mochten er dingen wijzigen, laat ons dit dan altijd weten zodat we alles goed voor jou kunnen regelen en verrekenen. Bijvoorbeeld als het aantal personen verandert, het diner verplaatst moet worden naar een andere datum, of als je extra’s bij wilt boeken.'
        },
        {
          title: 'Wanneer neemt de chef contact met mij op?',
          content: 'Wij geven je contactgegevens aan jouw cateraar en vragen om zo snel mogelijk (binnen 24 uur) contact met je op te nemen om het menu af te stemmen. Meestal lukt dit, maar vooral in de weekenden kan het te druk zijn om direct te reageren.'
        },
        {
          title: 'Kan ik mijn reservering nog annuleren?',
          content: 'Tot 7 dagen voor je diner kan je kosteloos annuleren. Stel ons op de hoogte en wij maken het volledige bedrag over naar je rekening. Als je binnen 7 dagen annuleert krijg je 50% van het totaalbedrag terug. Bij annuleringen vanaf 1 dag voor het diner kun je geen geld meer terugkrijgen.'
        },
        {
          title: 'Hoe moet ik het openstaande bedrag betalen?',
          content: 'Als je hebt gekozen voor een aanbetaling, dan wordt het resterende bedrag een week voor de datum van je diner afgeschreven. Je ontvangt tzt een mail hierover en hoeft verder niks te doen.'
        },
        {
          title: 'Wat gebeurt er met mijn geld als ik nu alvast betaal?',
          content: 'Alle betalingen op CHEFSTBL worden veilig bewaard op een derdengeldenrekening van Payaut, een onafhankelijke betaalprovider die aangesloten is bij De Nederlandsche Bank. Pas nadat het diner is uitgevoerd, wordt je betaling uitbetaald aan de cateraar. Hiermee voldoen we aan alle betalingsregels die gelden vanuit de overheid voor online dienstverleners.'
        },
        {
          title: 'Wanneer krijg ik mijn factuur?',
          content: 'Als je een factuur hebt aangevraagd sturen we je deze automatisch toe, zodra wij die van de cateraar hebben ontvangen. Meestal is dit direct na je diner.',
        }
      ]
    }
  }
})
